export default __webpack_public_path__ + "static/media/descuentoCard.c12861ea.svg";